import { useCallback, useState } from "react";
import { ObservationType } from "@tellescope/utils";
import { BlockProps } from "../types";
import { useBlock } from ".";

export type VitalsSubsection = "add-bp-reading" | "add-other-reading" | "vitals-subtype";

export interface VitalsSubtypeMetadata {
  title: string;
  observationId: string;
  observationType: ObservationType;
}

export interface UseVitalsBlockArgs extends BlockProps {}

export const useVitalsBlock = (args: UseVitalsBlockArgs) => {
  const block = useBlock({ ...args, type: "vitals.vitals", select: (enduser) => enduser });

  const [activeSubsection, setActiveSubsection] = useState<VitalsSubsection>();
  const [subtypeMetadata, setSubtypeMetadata] = useState<VitalsSubtypeMetadata>();

  const openSubtype = useCallback((metadata: VitalsSubtypeMetadata) => {
    setSubtypeMetadata(metadata);
    setActiveSubsection("vitals-subtype");
  }, []);

  const openAddReading = useCallback((type: "bp" | "other") => {
    setActiveSubsection(type === "bp" ? "add-bp-reading" : "add-other-reading");
  }, []);

  const closeSubsection = useCallback(() => {
    setActiveSubsection(undefined);
    setSubtypeMetadata(undefined);
  }, []);

  /** The observation whose row is expanded and whose point is highlighted on the chart. */
  const setObservationId = useCallback<
    (update: string | undefined | ((prev: string | undefined) => string | undefined)) => void
  >(
    (update) =>
      setSubtypeMetadata((prev) =>
        prev
          ? { ...prev, observationId: (typeof update === "function" ? update(prev.observationId) : update) ?? "" }
          : prev
      ),
    []
  );

  const enduser = block.enduserQuery.data;

  return {
    ...block,
    enduser,
    activeSubsection,
    subtypeMetadata,
    openSubtype,
    openAddReading,
    closeSubsection,
    setObservationId,
  };
};
